/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListPluginsSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListPluginsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListPluginsSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListPluginsSecurity$outboundSchema: z.ZodMiniType<
  ListPluginsSecurity$Outbound,
  ListPluginsSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listPluginsSecurityToJSON(
  listPluginsSecurity: ListPluginsSecurity,
): string {
  return JSON.stringify(
    ListPluginsSecurity$outboundSchema.parse(listPluginsSecurity),
  );
}

/** @internal */
export type ListPluginsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListPluginsRequest$outboundSchema: z.ZodMiniType<
  ListPluginsRequest$Outbound,
  ListPluginsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listPluginsRequestToJSON(
  listPluginsRequest: ListPluginsRequest,
): string {
  return JSON.stringify(
    ListPluginsRequest$outboundSchema.parse(listPluginsRequest),
  );
}
